module.exports = __webpack_public_path__ + "media/images/1-f74099f196ed8f7c18eaad65db03af2b.svg";